import DateFnsUtils from '@date-io/date-fns';
import { Box, Button, Card, CardHeader, createMuiTheme, FormControl, Grid, InputAdornment, Paper, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, TextField, Typography } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import SearchIcon from '@material-ui/icons/Search';
import MuiAlert from '@material-ui/lab/Alert';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import clsx from 'clsx';
import trLocale from 'date-fns/locale/tr';
import moment from 'moment';
import React, { useState } from 'react';
import axios from 'src/utils/axios';
import { getDifferenceInDays, getUser, sc } from 'src/utils/Common';
import LeftPane from './LeftPane';


function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  container: {
    maxHeight: 650,
    minHeight: 650,
  },
  fields: {
    paddingTop: 5,
  },
  box: {
    display: "flex",
    paddingTop: 15
  },
  centerBox: {
    justifyContent: "center",
    alignItems: "center"
  },
  cardHeader: {
    height: '10px'
  },
  cardScrollUst: {
    overflowY: "auto",
    margin: 0,
    padding: 0,
    maxHeight: 650,
    minHeight: 650,
    listStyle: "none",
    height: "100%",
    '&::-webkit-scrollbar': {
      width: '0.4em'
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,.1)',
      outline: '0px solid slategrey'
    }
  },
}));
const materialTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#FF9800',
      dark: '#424242',
      main: '#424242',
      light: '#424242'
    }
  }
});
const localeMap = {
  tr: trLocale
};

const entryListCells = [
  { id: 'TARIH', numeric: false, disablePadding: true, label: 'Tarih' },
  { id: 'MALZEME_STOK_NO', numeric: false, disablePadding: true, label: 'Malzeme' },
  { id: 'TIP', numeric: false, disablePadding: true, label: 'Tip' },
  { id: 'ADET', numeric: true, disablePadding: true, label: 'Adet' },
  { id: 'ISLEM_YAPAN', numeric: false, disablePadding: true, label: 'İşlemYapan' },
  { id: 'FATURA_ADET', numeric: true, disablePadding: true, label: 'FaturaAdet' },
  { id: 'FATURA_NO', numeric: false, disablePadding: true, label: 'Fatura' },
];
const exitListCells = [
  { id: 'TARIH', numeric: false, disablePadding: true, label: 'Tarih' },
  { id: 'MALZEME_STOK_NO', numeric: false, disablePadding: true, label: 'Malzeme' },
  { id: 'TIP', numeric: false, disablePadding: true, label: 'Tip' },
  { id: 'ADET', numeric: true, disablePadding: true, label: 'Adet' },
  { id: 'ISLEM_YAPAN', numeric: false, disablePadding: true, label: 'İşlemYapan' },
  { id: 'CIKIS_YERI', numeric: false, disablePadding: true, label: 'ÇıkışYeri' },
  { id: 'TEKNISYEN', numeric: false, disablePadding: true, label: 'Teknisyen' },
];
const returnListCells = [
  { id: 'TARIH', numeric: false, disablePadding: true, label: 'Tarih' },
  { id: 'MALZEME_STOK_NO', numeric: false, disablePadding: true, label: 'Malzeme' },
  { id: 'TIP', numeric: false, disablePadding: true, label: 'Tip' },
  { id: 'ADET', numeric: true, disablePadding: true, label: 'Adet' },
  { id: 'ISLEM_YAPAN', numeric: false, disablePadding: true, label: 'İşlemYapan' },
  { id: 'TEKNISYEN', numeric: false, disablePadding: true, label: 'Teknisyen' },
];

function RightPane(props) {
  const classes = useStyles();

  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('');

  const today = moment(new Date()).format('YYYY-MM-DD');
  const [baslangicTarihi, setBaslangicTarihi] = useState(today);
  const [bitisTarihi, setBitisTarihi] = useState(today);

  const [data, setData] = useState({});
  const [filtered, setFiltered] = useState({});

  const handleSorgula = () => {
    if (getDifferenceInDays(new Date(baslangicTarihi), new Date(bitisTarihi)) > 10) {
      setUyariTip("error");
      setUyariAciklama("İki tarih aralığı 10 günden büyük olamaz!...");
      setUyari(true);
      return
    }
    props.setLoading(true);
    const user = getUser();
    axios.get(`GetInventoryReport/${user.ServiceShopId}/${baslangicTarihi}/${bitisTarihi}`)
      .then(res => {
        setData(res.data);
        setFiltered(res.data);
        props.setLoading(false);
      }).catch(err => {
        setData({});
        setFiltered({});
        props.setLoading(false);
      })
  }

  const handleDateChange = (event, type) => {
    var Deger = moment(event).format('YYYY-MM-DD');
    type === 1 ? setBaslangicTarihi(Deger) : setBitisTarihi(Deger);
  };

  function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort, Header } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };
    return (
      <TableHead>
        <TableRow>
          {Header.map((headCell) => (
            <TableCell padding='none'
              key={headCell.id}
              align={'center'}
              padding={headCell.disablePadding ? 'none' : 'default'}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {''}
                  </span>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  const [sm, setSm] = useState({ entry: 4, exit: 4, return: 4 });

  const [search, setSearch] = useState('');
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();

  const handleSearch = (newValue) => {
    let oldData = { ...data };
    setSearch(newValue);

    let filteredEntry = oldData.entryList.filter(item =>
      sc(item.TIP, newValue)
      || sc(item.ISLEM_YAPAN, newValue)
      || sc(item.FATURA_NO, newValue)
    );

    let filteredExit = oldData.exitList.filter(item =>
      sc(item.TIP, newValue)
      || sc(item.ISLEM_YAPAN, newValue)
      || sc(item.CIKIS_YERI, newValue)
      || sc(item.TEKNISYEN, newValue)
    );

    let filteredReturn = oldData.returnList.filter(item =>
      sc(item.TIP, newValue)
      || sc(item.ISLEM_YAPAN, newValue)
      || sc(item.TEKNISYEN, newValue)
    );

    setFiltered({
      entryList: filteredEntry,
      exitList: filteredExit,
      returnList: filteredReturn
    });


  }
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  return (
    <div>
      <Snackbar open={uyari} autoHideDuration={6000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={uyariKapat}>
        <Alert onClose={uyariKapat} severity={uyariTip}>
          {uyariAciklama || ''}
        </Alert>
      </Snackbar>
      <Paper>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={2}>
            <LeftPane loading={props.loading} title={"Stok Çeşidi"} value={props.statistics.CESIT} />
          </Grid>
          <Grid item xs={12} sm={2}>
            <LeftPane loading={props.loading} title={"Stok Tutarı (Alım)"} value={props.statistics.ALISKDVSIZ} />

          </Grid>
          <Grid item xs={12} sm={2}>
            <LeftPane loading={props.loading} title={"Stok Tutarı (Satış)"} value={props.statistics.SATISKDVSIZ} />
          </Grid>
          <Grid item xs={12} sm={1} title={"Başlangıç tarihi"} >
            <FormControl variant="outlined" className={classes.fields}>
              <Typography variant="h6" component="h2">
                <ThemeProvider theme={materialTheme}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={localeMap['tr']}
                  >
                    <KeyboardDatePicker
                      color="primary"
                      fullWidth
                      inputVariant="outlined"
                      invalidDateMessage={'Hatalı Tarih Formatı'}
                      format={'dd.MM.yy'}
                      variant="outlined"
                      value={baslangicTarihi}
                      onChange={e => handleDateChange(e, 1)}
                      KeyboardButtonProps={{
                        'aria-label': 'change date'
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </ThemeProvider>
              </Typography>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={1} title={"Bitiş tarihi"}>
            <FormControl variant="outlined" className={classes.fields}>
              <Typography variant="h6" component="h2">
                <ThemeProvider theme={materialTheme}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={localeMap['tr']}
                  >
                    <KeyboardDatePicker
                      color="primary"
                      fullWidth
                      inputVariant="outlined"
                      invalidDateMessage={'Hatalı Tarih Formatı'}
                      format={'dd.MM.yy'}
                      variant="outlined"
                      value={bitisTarihi}
                      onChange={e => handleDateChange(e, 2)}
                      KeyboardButtonProps={{
                        'aria-label': 'change date'
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </ThemeProvider>
              </Typography>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={1}
            align='center'
            justify='center'
          >
            <Box
              component="div"
              m={1}
              className={`${classes.centerBox} ${classes.box}`}
            >
              <Button
                variant="contained"
                color="secondary"
                endIcon={<SearchIcon>Sorgula</SearchIcon>}
                onClick={() => handleSorgula()}>
                Sorgula
       </Button>
            </Box>
          </Grid>
          <Grid item xs={12} sm={3}>

            <FormControl fullWidth className={classes.margin} style={{ paddingTop: '15px' }}>
              <TextField
                label="Arama Yapınız..."
                value={search}
                className={clsx(classes.margin, classes.textField)}
                onChange={e => handleSearch(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon />
                    </InputAdornment>
                  )
                }}
              />
            </FormControl>
          </Grid>


        </Grid>

      </Paper>
      <br />
      <Paper>
        <Grid container spacing={1}>
          <Grid xs={12} sm={sm.entry} style={{ paddingRight: '10px' }}>
            <Card spacing={2}>
              <CardHeader title="Malzeme Giriş İşlemleri" className={classes.cardHeader}
                action={sm.entry === 8 ?
                  <RemoveIcon onClick={() => sm.entry === 8 ? setSm({ entry: 4, exit: 4, return: 4 }) : setSm({ entry: 8, exit: 2, return: 2 })} />
                  :
                  <AddIcon onClick={() => sm.entry === 8 ? setSm({ entry: 4, exit: 4, return: 4 }) : setSm({ entry: 8, exit: 2, return: 2 })} />
                }
              />
              <TableContainer style={{ width: '100%' }} className={classes.cardScrollUst}>
                <Table
                  stickyHeader
                  className={classes.table}
                  aria-labelledby="tableTitle"
                  size={'small'}>
                  <EnhancedTableHead
                    classes={classes}
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    Header={entryListCells}
                  />
                  <TableBody>
                    {stableSort(filtered.entryList || [], getComparator(order, orderBy))
                      .map((row, index) => (
                        <TableRow key={index}>
                          <TableCell padding='none' align="left" className={classes.tableCell}>
                            {row.TARIH}
                          </TableCell>
                          <TableCell padding='none' title={row.MALZEME} align="left" className={classes.tableCell}>
                            {row.MALZEME_STOK_NO}  {row.MALZEME.substring(0, 10)}...
                          </TableCell>
                          <TableCell padding='none' align="left" className={classes.tableCell}>
                            {row.TIP}
                          </TableCell>
                          <TableCell padding='none' align="center" className={classes.tableCell}>
                            {row.ADET}
                          </TableCell>
                          <TableCell padding='none' align="left" className={classes.tableCell}>
                            {row.ISLEM_YAPAN}
                          </TableCell>
                          <TableCell padding='none' align="center" className={classes.tableCell}>
                            {row.FATURA_ADET}
                          </TableCell>
                          <TableCell padding='none' align="left" className={classes.tableCell}>
                            {row.FATURA_NO}
                          </TableCell>

                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          </Grid>
          <Grid xs={12} sm={sm.exit} style={{ paddingRight: '10px' }}>
            <Card spacing={2}>
              <CardHeader title="Malzeme Çıkış İşlemleri" className={classes.cardHeader}
                action={sm.exit === 8 ?
                  <RemoveIcon onClick={() => sm.exit === 8 ? setSm({ entry: 4, exit: 4, return: 4 }) : setSm({ entry: 2, exit: 8, return: 2 })} />
                  :
                  <AddIcon onClick={() => sm.exit === 8 ? setSm({ entry: 4, exit: 4, return: 4 }) : setSm({ entry: 2, exit: 8, return: 2 })} />
                }
              />
              <TableContainer variant='outlined' style={{ width: '100%' }} className={classes.cardScrollUst}>
                <Table
                  stickyHeader
                  className={classes.table}
                  aria-labelledby="tableTitle"
                  size={'small'}>
                  <EnhancedTableHead
                    classes={classes}
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    Header={exitListCells}
                  />
                  <TableBody>
                    {stableSort(filtered.exitList || [], getComparator(order, orderBy))
                      .map((row, index) => (
                        <TableRow key={index}>
                          <TableCell padding='none' align="left" className={classes.tableCell}>
                            {row.TARIH}
                          </TableCell>
                          <TableCell padding='none' title={row.MALZEME} align="left" className={classes.tableCell}>
                            {row.MALZEME_STOK_NO}  {row.MALZEME.substring(0, 10)}...
                          </TableCell>
                          <TableCell padding='none' align="left" className={classes.tableCell}>
                            {row.TIP}
                          </TableCell>
                          <TableCell padding='none' align="center" className={classes.tableCell}>
                            {row.ADET}
                          </TableCell>
                          <TableCell padding='none' align="left" className={classes.tableCell}>
                            {row.ISLEM_YAPAN}
                          </TableCell>
                          <TableCell padding='none' align="left" className={classes.tableCell}>
                            {row.CIKIS_YERI}
                          </TableCell>
                          <TableCell padding='none' align="left" className={classes.tableCell}>
                            {row.TEKNISYEN}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          </Grid>
          <Grid xs={12} sm={sm.return}>
            <Card spacing={2}>
              <CardHeader title="Zimmet İşlemleri" className={classes.cardHeader}
                action={sm.return === 8 ?
                  <RemoveIcon onClick={() => sm.return === 8 ? setSm({ entry: 4, exit: 4, return: 4 }) : setSm({ entry: 2, exit: 2, return: 8 })} />
                  :
                  <AddIcon onClick={() => sm.return === 8 ? setSm({ entry: 4, exit: 4, return: 4 }) : setSm({ entry: 2, exit: 2, return: 8 })} />
                }
              />
              <TableContainer style={{ width: '100%' }} className={classes.cardScrollUst}>
                <Table
                  stickyHeader
                  className={classes.table}
                  aria-labelledby="tableTitle"
                  size={'small'}>
                  <EnhancedTableHead
                    classes={classes}
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    Header={returnListCells}
                  />
                  <TableBody>
                    {stableSort(filtered.returnList || [], getComparator(order, orderBy))
                      .map((row, index) => (
                        <TableRow key={index}>
                          <TableCell padding='none' align="left" className={classes.tableCell}>
                            {row.TARIH}
                          </TableCell>
                           <TableCell padding='none' title={row.MALZEME} align="left" className={classes.tableCell}>
                            {row.MALZEME_STOK_NO}  {row.MALZEME.substring(0, 10)}...
                          </TableCell>
                          <TableCell padding='none' align="left" className={classes.tableCell}>
                            {row.TIP}
                          </TableCell>
                          <TableCell padding='none' align="center" className={classes.tableCell}>
                            {row.ADET}
                          </TableCell>
                          <TableCell padding='none' align="left" className={classes.tableCell}>
                            {row.ISLEM_YAPAN}
                          </TableCell>
                          <TableCell padding='none' align="left" className={classes.tableCell}>
                            {row.TEKNISYEN}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          </Grid>
        </Grid>
      </Paper>
    </div>

  );
}





export default RightPane;
